export const data = {
    title: 'Transforming your vision into a digital reality',
    subtitle: 'Website and Apps Development Agency',
    btn: 'Get a quote'
}